import React, { useState } from "react";
import { Table, Input, Button, Space } from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";

const DataTable = ({
  size = "100%",
  data = [],
  columns = [],
  loading = false,
  actions = {},
  expandable = null, // <-- Aqui adicionamos o suporte
}) => {
  const [searchText, setSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const filteredData = data?.filter((item) => {
    return Object.keys(item).some((key) =>
      String(item[key]).toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const columnsWithActions =
    actions && Object.keys(actions).length > 0
      ? [
          ...columns,
          {
            title: "Ações",
            key: "actions",
            render: (text, record) => (
              <Space size="middle">
                {actions.onEdit && (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#054F72" }}
                    onClick={() => actions.onEdit(record)}
                  >
                    Editar
                  </Button>
                )}
                {actions.onView && (
                  <Button
                    type="default"
                    icon={<EyeOutlined />}
                    onClick={() => actions.onView(record)}
                    aria-label="Ver"
                    title="Ver"
                  />
                )}
                {actions.goToContractor && (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#67a538" }}
                    onClick={() => actions.goToContractor(record)}
                  >
                    Contratante
                  </Button>
                )}
                {actions.onPdf && (
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#67a538" }}
                    onClick={() => actions.onPdf(record)}
                  >
                    Baixar PDF
                  </Button>
                )}
                {actions.onDelete && (
                  <Button
                    style={{ backgroundColor: "#ff4444", color: "white" }}
                    type="danger"
                    onClick={() => actions.onDelete(record)}
                  >
                    Excluir
                  </Button>
                )}
              </Space>
            ),
          },
        ]
      : columns;

  const rowSelection = {
    selectedRowKeys,
    onChange: handleSelectChange,
  };

  return (
    <div
      className="flex flex-col border-solid border-[1px] border-[#ebebeb] rounded-lg bg-white"
      style={{ width: size }}
    >
      <div className="p-4">
        <Input
          placeholder="Buscar..."
          style={{
            fontSize: "16px",
            padding: "6px",
            border: "transparent",
            backgroundColor: "white",
            fontFamily: "mulish",
            width: "30%",
          }}
          prefix={<SearchOutlined />}
          onChange={handleSearch}
        />
      </div>

      <Table
        // rowSelection={rowSelection}
        columns={columnsWithActions}
        dataSource={filteredData}
        loading={loading}
        pagination={false}
        rowKey="id"
        className="rounded-lg"
        style={{ width: "100%", overflowX: "auto", backgroundColor: "white" }}
        expandable={expandable} // <-- Aqui aplicamos!
      />
    </div>
  );
};

export default DataTable;
